export default __webpack_public_path__ + "static/media/logo-cdz.a57b2d05.png";